export const mmSsToSeconds = (mm, ss) => mm * 60 + ss;
export const calculateMinutes = value => Math.floor(value / 60);
export const calculateSeconds = value => value % 60;
